module.exports = __webpack_public_path__ + "media/pages/book/components/images/main-features/hand-picked-3bae000d9dfb92e104664e047046b0cf.svg";